export type Lang = "bg" | "en" | "de" | "gr";

// Display order is important for the navbar: BG, EN, GR, DE
export const LANGUAGES: Array<{ code: Lang; label: string; tld: string }> = [
  { code: "bg", label: "BG", tld: ".bg" },
  { code: "en", label: "EN", tld: ".eu" },
  { code: "gr", label: "GR", tld: ".gr" },
  { code: "de", label: "DE", tld: ".de" },
];

export const DEFAULT_LANG: Lang = "bg";

export function isSupportedLang(value: string | undefined | null): value is Lang {
  return value === "bg" || value === "en" || value === "de" || value === "gr";
}
